import type {
  IUserSuggestedUpdateAcceptUpdateParams,
  IUserSuggestedUpdateAcceptUpdateRequest,
  IUserSuggestedUpdateAcceptUpdateResponse,
} from '@/app-package';

import axios from 'axios';

const acceptUpdate = async (params: IUserSuggestedUpdateAcceptUpdateParams) => {
  const config: IUserSuggestedUpdateAcceptUpdateRequest = {
    url: `suggested_user_update/accept_update/${params.suggestedUpdateId}`,
    method: 'post',
  };

  const { data } =
    await axios.request<IUserSuggestedUpdateAcceptUpdateResponse>(config);

  return data;
};

export default acceptUpdate;
